"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../theme");
var typography_1 = require("../../typography");
exports.Wrapper = (0, styled_components_1.default)(typography_1.Label).attrs(function () { return ({
    inline: true,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  white-space: nowrap;\n  line-height: 1 !important;\n  border-radius: 100px;\n  background-color: ", ";\n  padding: 0.35em 0.5em 0.25em 0.5em;\n  color: ", ";\n  ", "\n"], ["\n  position: relative;\n  display: inline-block;\n  white-space: nowrap;\n  line-height: 1 !important;\n  border-radius: 100px;\n  background-color: ", ";\n  padding: 0.35em 0.5em 0.25em 0.5em;\n  color: ", ";\n  ", "\n"])), theme_1.theme.colors.YELLOW_40, theme_1.theme.colors.BLUE_50, function (_a) {
    var $floating = _a.$floating;
    return ($floating ? theme_1.theme.elevation.ELEVATION_50 : '');
});
var templateObject_1;
